export default "__VITE_ASSET__Cu0g$SQe__"